<template>
  <div class="language">
    <button @click="$i18n.locale = 'sv'">
      <img class="images"
           src="./../images/flags/SE_small.png"
           alt="Swedish flag"
      >
    </button>
    <button @click="$i18n.locale = 'en'">
      <img class="images"
           src="./../images/flags/GB_small.png"
           alt="British flag"
      >
    </button>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.language {
    float: right;

    button {
        margin: 3px;
        font-size: 30px;
    }
    .images{
        width: 30px;
    }
}
</style>